/**
 * Risk color enum as sent by the backend for maxInitialRisk / maxResidualRisk.
 * Hex values must match --ra-*-risk-color in variables.scss.
 */
export enum RaRiskColor {
  Green = 0,
  Yellow = 1,
  Red = 2,
}

export const RA_RISK_COLOR_HEX: Record<RaRiskColor, string> = {
  [RaRiskColor.Green]: '#008000',
  [RaRiskColor.Yellow]: '#ffff00',
  [RaRiskColor.Red]: '#ff0000',
};
